import { Box } from "@mui/material";
import { Error404Component } from "components";

export const Error404Screen = () => {
  return (
    <Box width={"100vw"} height={"calc(100% - 64px)"}>
      <Error404Component />
    </Box>
  );
};
